import AuthWrapper from "./components/AuthWrapper/AuthWrapper"
import { TokenContext } from "./components/AuthWrapper/AuthWrapper"
import { useContext } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { useLocation } from "react-router-dom"
import ErrorPage from "./pages/Error/ErrorPage"
import SurveyEditRedirect from "./routes/SurveyEditRedirect"
import ReportRouter from "./pages/Report/ReportRouter"
import Loading from "./components/Loading/Loading"
import {
  Home,
  LegalInformation,
  SurveyPage,
  SurveyResultPage,
  SurveyStartPage,
  RessourcesPage
} from "./pages"

function ProtectedRoute({ PageComponent }) {
  const token = useContext(TokenContext);
  const location = useLocation();
  const { user, isAuthenticated, isLoading: authLoading } = useAuth0();

  let isPuppeteer = false;

  if (typeof window !== "undefined") {
    const searchParams = new URLSearchParams(window.location.search);
    const printToken = searchParams.get("printToken");

    if (printToken) window.__puppeteerAuth = true;

    isPuppeteer =
      window.__puppeteerAuth &&
      (process.env.REACT_APP_ALLOW_PUPPETEER === "true" ||
        process.env.NODE_ENV === "development");
  }

  if (isPuppeteer) {
    return <PageComponent token={token} />;
  }

  if (authLoading) {
    return <Loading open={true} opacity={1} message="Chargement..." />;
  }

  if (!isAuthenticated || !user) {
    return <Loading open={true} opacity={1} message="Chargement..." />;
  }

  const roles = user?.["https://digitalwallonia.be/role"] || [];

  if (
    location.pathname.startsWith("/report") &&
    !(roles.includes("DIGISCORE_SCRIBE") || roles.includes("DIGISCORE_ADMIN"))
  ) {
    return <div>No access</div>;
  }

  return <PageComponent token={token} />;
}


const router = [
  // Public routes
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/error",
    element: <ErrorPage />
  },
  {
    path: "/legalinformation",
    element: <LegalInformation />
  },
  {
    path: "/report/:sessionId",
    element: (
      <AuthWrapper returnTo={"/report"}>
        <ProtectedRoute PageComponent={ReportRouter} />
      </AuthWrapper>
    )
  },

  // Protected routes
  {
    path: "/survey",
    element: (
      <AuthWrapper returnTo={"/survey"}>
        <ProtectedRoute PageComponent={SurveyPage} />
      </AuthWrapper>
    )
  },
  {
    path: "/survey/:surveyId",
    element: (
      <AuthWrapper returnTo={"/survey"}>
        <SurveyEditRedirect />
      </AuthWrapper>
    )
  },
  {
    path: "/survey/start",
    element: (
      <AuthWrapper returnTo={"/survey/start"}>
        <ProtectedRoute PageComponent={SurveyStartPage} />
      </AuthWrapper>
    )
  },
  {
    path: "/survey/result/:params",
    element: (
      <AuthWrapper returnTo={"/survey/result"}>
        <ProtectedRoute PageComponent={SurveyResultPage} />
      </AuthWrapper>
    )
  },
  {
    path: "/ressources",
    element: (
      <AuthWrapper returnTo={"/ressources"}>
        <ProtectedRoute PageComponent={RessourcesPage} />
      </AuthWrapper>
    )
  }
]

export default router